import { combineReducers, createAction } from "@reduxjs/toolkit";
import authReducer from "../toolkit/auth/authSlice";
import sellMyCar from "../toolkit/sellMyCar/sellMyCarSlice";
import sellerSidebarReducer from "../toolkit/sidebar/sidebarSlice";
import alertDialogReducer from "../toolkit/alertDialog/alertDialogSlice";
import carSlice from "../toolkit/carEstimate/carEstimateSlice";
import myGarage from "../toolkit/myGarage/myGarageSlice";
import liveAuction from "../toolkit/liveAuction/liveAuctionSlice";
import buyNow from "../toolkit/buyNow/buyNowSlice";
import carsInNegotiation from "../toolkit/carsInNegotiation/carsInNegotiationSlice";
import { authApi } from "../toolkit/auth/authApi";
import { signinApi } from "../toolkit/signin/signinApi";
import { carEstimateApi } from "../toolkit/carEstimate/carEstimateApi";
import { reducerPaths } from "./reducerPaths";
import { myGarageApi } from "../toolkit/myGarage/myGarageApi";
import { sellMyCarApi } from "../toolkit/sellMyCar/sellMyCarApi";
import { carDetailsApi } from "../toolkit/carDetails/carDetailsApi";
import { upcomingCarsApi } from "../toolkit/upcomingCars/upcomingCarsApi";
import { liveAuctionApi } from "../toolkit/liveAuction/liveAuctionApi";
import { carsInNegotiationApi } from "../toolkit/carsInNegotiation/carsInNegotiationApi";
import { dashboardReportApi } from "../toolkit/dashboardReport/dashboardReportApi";
import { contactUsApi } from "../toolkit/contactUs/contactUsApi";
import { vehicleApi } from "../toolkit/vehicle/vehicleApi";
import { geographyApi } from "../toolkit/geography/geographyApi";
import { paypalApi } from "../toolkit/paypal/paypalApi";
import { carfaxApi } from "../toolkit/carfax/carfaxApi";
import { buyNowApi } from "../toolkit/buyNow/buyNowApi";
import { watchListApi } from "src/toolkit/watchList/watchListApi";
import { myOrdersApi } from "src/toolkit/myOrders/myOrdersApi";
import { walletAndPaymentsApi } from "@common/toolkit/walletAndPayments/walletAndPaymentsApi";
import { dashboardPaginationFiltersApi } from "src/toolkit/dashboardPaginationFilters/dashboardPaginationFiltersApi";
import { signupApi } from "src/toolkit/auth/signupApi";
import { paymentsApi } from "src/toolkit/payments/paymentsApi";

export const revertAll = createAction("REVERT_ALL");

export const rootReducer = combineReducers({
  auth: authReducer,
  [reducerPaths.signupApi]: signupApi.reducer,
  [reducerPaths.sidebar]: sellerSidebarReducer,
  alertDialog: alertDialogReducer,
  [reducerPaths.carEstimateSlice]: carSlice,
  [reducerPaths.sellMyCarDashboard]: sellMyCar,
  [reducerPaths.myGarage]: myGarage,
  [reducerPaths.liveAuction]: liveAuction,
  [reducerPaths.buyNow]: buyNow,
  [reducerPaths.carsInNegotiation]: carsInNegotiation,
  [reducerPaths.authApi]: authApi.reducer,
  [signinApi.reducerPath]: signinApi.reducer,
  [carEstimateApi.reducerPath]: carEstimateApi.reducer,
  [carDetailsApi.reducerPath]: carDetailsApi.reducer,
  [myGarageApi.reducerPath]: myGarageApi.reducer,
  [sellMyCarApi.reducerPath]: sellMyCarApi.reducer,
  [upcomingCarsApi.reducerPath]: upcomingCarsApi.reducer,
  [reducerPaths.buyNowApi]: buyNowApi.reducer,
  [liveAuctionApi.reducerPath]: liveAuctionApi.reducer,
  [carsInNegotiationApi.reducerPath]: carsInNegotiationApi.reducer,
  [vehicleApi.reducerPath]: vehicleApi.reducer,
  [dashboardReportApi.reducerPath]: dashboardReportApi.reducer,
  [contactUsApi.reducerPath]: contactUsApi.reducer,
  [reducerPaths.geographyApi]: geographyApi.reducer,
  [reducerPaths.paypalApi]: paypalApi.reducer,
  [reducerPaths.carfaxApi]: carfaxApi.reducer,
  [reducerPaths.watchListApi]: watchListApi.reducer,
  [reducerPaths.myOrdersApi]: myOrdersApi.reducer,
  [reducerPaths.walletAndPaymentsApi]: walletAndPaymentsApi.reducer,
  [reducerPaths.paymentsApi]:
    paymentsApi.reducer,
});